var map = {
	"./sms-error.svg": 5443,
	"./sms-location.svg": 9159,
	"./sms-manual.svg": 9560,
	"./sms-ok.svg": 2368,
	"./sms-press-static.svg": 9914,
	"./sms-press.svg": 1727,
	"./sms-text.svg": 7791,
	"./sms-video.svg": 8767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5691;